import { render, staticRenderFns } from "./LmFormSubtittles.vue?vue&type=template&id=08a7d043&"
import script from "./LmFormSubtittles.vue?vue&type=script&lang=js&"
export * from "./LmFormSubtittles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports